import React from 'react';

// #323 — Card de upsell "no lugar" de uma feature Pro+ bloqueada por tier
// (Dashboard / NC-para-fornecedor / Alertas de gestão). Presentational puro,
// espelha o visual âmbar do SecaoBloqueadaUpsell (#163). NÃO é o gate: o gate
// autoritativo é o 403 do backend; aqui é só a UX (corte seco + upsell).
//
// Renderiza SÓ quando o sinal do /auth/me (dashboard_liberado / outbound_liberado
// / alertas_gestao_liberado) vem `false` — o que só acontece com
// GATING_FEATURES_HABILITADO ligado E plano abaixo do Pro. Com a flag OFF
// (default), o sinal é `true` e este componente nunca aparece.
export default function UpsellPro({ icone = 'lock', titulo, descricao, plano = 'Pro', compacto = false }) {
  return (
    <section className={compacto ? '' : 'result-section'} style={{ opacity: 0.96 }}>
      <div style={{
        display: 'flex', flexDirection: 'column', gap: '10px',
        padding: compacto ? '16px 18px' : '22px 24px',
        border: '1px dashed #fcd34d', borderRadius: '10px', background: '#fffbeb',
        maxWidth: '620px',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span className="material-symbols-outlined" style={{ fontSize: '20px', color: '#b45309' }}>{icone}</span>
          <h3 style={{ margin: 0, color: '#92400e', fontSize: compacto ? '15px' : '17px' }}>{titulo}</h3>
          <span style={{
            fontSize: '11px', fontWeight: 700, letterSpacing: '0.04em',
            textTransform: 'uppercase', color: '#b45309', background: '#fef3c7',
            border: '1px solid #fcd34d', borderRadius: '4px', padding: '2px 6px',
          }}>{plano}</span>
        </div>
        <p style={{ margin: 0, color: '#78350f', fontSize: '13.5px', lineHeight: 1.5 }}>{descricao}</p>
        <p style={{ margin: 0, color: '#92400e', fontSize: '12.5px' }}>
          Disponível a partir do plano <strong>{plano}</strong>. Fale com a gente para liberar.
        </p>
      </div>
    </section>
  );
}
